import { useQuery } from 'react-query'

import httpClient from 'services/http-client'

import { TEN_MINUTES_STALE_TIME } from 'constants/apis'

const GET_BRANDS_MOV = '/brands/minimum-order-values'

type BransMov = Record<string, number | null>

const useGetBrandListMovByCurrency = (brandIds: string[], toCurrency: string) => {
  return useQuery({
    queryKey: [GET_BRANDS_MOV, brandIds, toCurrency],
    queryFn: async () => {
      const { data } = await httpClient.post<BransMov>(GET_BRANDS_MOV, { brandIds, currency: toCurrency })
      return data
    },
    staleTime: TEN_MINUTES_STALE_TIME,
    enabled: brandIds.length > 0,
  })
}

export default useGetBrandListMovByCurrency
